export default "__VITE_ASSET__BIKePHqz__"